import Api from '@common/services/api';
import { APIResponseNoteCreate, APIResponseNotesDelete, NotesModel } from '@modules/core/types';
import { SimpleUser } from '@common/types/objects';

export const createNote = async (
    organisationId: string,
    userId: string,
    payload: any,
): Promise<APIResponseNoteCreate> => {
    return Api.post<APIResponseNoteCreate>(`/v1/organisations/${organisationId}/users/${userId}/notes`, payload);
};

export const getNotes = async (
    organisationId: string,
    userId: string,
): Promise<{ data: NotesModel[], meta: { related: { users: SimpleUser[] } } }> => {
    return Api.get<{
        data: NotesModel[],
        meta: { related: { users: SimpleUser[] } }
    }>(`/v1/organisations/${organisationId}/users/${userId}/notes`);
};

export const getNotesEndpoint = (organisationId: string, userId: string) => {
    return `/v1/organisations/${organisationId}/users/${userId}/notes`;
};

export const deleteNote = async (organisationId: string, userId: string, noteId: string): Promise<APIResponseNotesDelete> => {
    return Api.delete<APIResponseNotesDelete>(`/v1/organisations/${organisationId}/users/${userId}/notes/${noteId}`);
};
